import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-neutral-200">
      <div className="flex flex-col bg-neutral-300 w-56 h-64 animate-pulse rounded-xl p-4 gap-4">
        <div className="bg-neutral-400/50 w-full h-32 animate-pulse rounded-md" />
        <div className="flex flex-col gap-2">
          <div className="bg-neutral-400/50 w-full h-4 animate-pulse rounded-md" />
          <div className="bg-neutral-400/50 w-4/5 h-4 animate-pulse rounded-md" />
          <div className="bg-neutral-400/50 w-full h-4 animate-pulse rounded-md" />
          <div className="bg-neutral-400/50 w-2/4 h-4 animate-pulse rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
